export default [

     {
          path: '/maturity',
          name: 'Maturity',
          component: () => import("@/views/Page/Maturity/Maturity.vue"),
           meta: {
               title: 'Maturity',
          },
     }
];